module.exports = __webpack_public_path__ + "static/media/icon_chevron_right.b4af1ddc.svg";